import { useToastStore } from '../stores/toast'

export function useToast() {
  const toastStore = useToastStore()

  return {
    toast: (message, options = {}) => toastStore.addToast({ message, ...options }),
    success: (message, options = {}) => toastStore.success(message, options),
    error: (message, options = {}) => toastStore.error(message, options),
    warning: (message, options = {}) => toastStore.warning(message, options),
    info: (message, options = {}) => toastStore.info(message, options),

    remove: (id) => toastStore.removeToast(id),
    clear: () => toastStore.clearAllToasts(),

    toasts: toastStore.toasts,
  }
}
